import { Avatar, AvatarGroup } from '@/components/ui/avatar'

type Props = {
  avatars: Array<{
    id?: string
    name: string
    url?: string
    color?: string
  }>
}
export const StackedAvatars = ({ avatars }: Props) => {
  return (
    <AvatarGroup>
      {avatars.map((avatar) => (
        <Avatar
          key={avatar.id ?? avatar.name}
          name={avatar.name}
          src={avatar.url}
          size={'sm'}
          position={'relative'}
          zIndex={2}
          _before={{
            content: '""',
            width: 'full',
            height: 'full',
            rounded: 'full',
            transform: 'scale(1.125)',
            bgColor: avatar.color,
            position: 'absolute',
            zIndex: -1,
            top: 0,
            left: 0,
          }}
        />
      ))}
    </AvatarGroup>
  )
}
